import Decimal from 'decimal.js';
import { AvailableCreditModel } from "./AvailableCreditModel";
import { BillableStateType } from "./billable-state";
import { fromResponseDTO } from "./manual-service-billing";
export class BillingControlDataModel {
  static fromDTO(dto) {
    const credits = dto.credits.map(c => new AvailableCreditModel(c));
    return new BillingControlDataModel(fromResponseDTO(dto.manualServices), credits, AvailableCreditModel.sumCredits(credits));
  }
  static make() {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const credits = data.credits || [];
    return new BillingControlDataModel(data.manualServices || {}, credits, AvailableCreditModel.sumCredits(credits));
  }
  constructor(manualServices, credits, totalCredits) {
    this.manualServices = manualServices;
    this.credits = credits;
    this.totalCredits = totalCredits;
  }
  getManualServiceBilling(serviceId) {
    return this.manualServices[serviceId];
  }
  getManualServiceBillingStages(serviceId) {
    var _this$manualServices$;
    return ((_this$manualServices$ = this.manualServices[serviceId]) === null || _this$manualServices$ === void 0 ? void 0 : _this$manualServices$.billingStages) || [];
  }
  getAlreadyBilledAmount(serviceId) {
    var _this$manualServices$2;
    return ((_this$manualServices$2 = this.manualServices[serviceId]) === null || _this$manualServices$2 === void 0 ? void 0 : _this$manualServices$2.billedAmount) || new Decimal(0);
  }
  getIsBillable(serviceId) {
    var _this$manualServices$3;
    return ((_this$manualServices$3 = this.manualServices[serviceId]) === null || _this$manualServices$3 === void 0 ? void 0 : _this$manualServices$3.billableState.type) === BillableStateType.Billable;
  }
  getNonBillableReason(serviceId) {
    var _this$manualServices$4, _billableState$nonBil;
    const billableState = (_this$manualServices$4 = this.manualServices[serviceId]) === null || _this$manualServices$4 === void 0 ? void 0 : _this$manualServices$4.billableState;
    if (!billableState) {
      return null;
    }
    if (billableState.type === BillableStateType.Billable) {
      return null;
    }
    return ((_billableState$nonBil = billableState.nonBillable) === null || _billableState$nonBil === void 0 ? void 0 : _billableState$nonBil.reason) || null;
  }
  getManualServices() {
    return this.manualServices;
  }
  getTotalCredits() {
    return this.totalCredits;
  }
}